<template>
    <section class="blog__f1__container">
            <div class="title" v-if="fields" data-animate="slideUp">{{ fields['Title section'] }}</div>
            <div class="desc" v-if="fields" data-animate="slideUp">{{ fields['Text section'] }}</div>
            <div class="wrapper">
                <slot name="search"></slot>
                <slot name="sortby"></slot>
            </div>
    </section>
</template>

<script>
    export default {
        props: {
          fields: [Array,Object],
        },
    }
</script>

<style scoped>
.wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
}
.blog__f1__container{
    padding-top: 80px;
    padding-bottom: 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    position: relative;
}
.blog__f1__container .title{
    /* Header/H1: 44px Medium */
    color: rgb(5, 5, 5);;
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.blog__f1__container .desc{
/* Paragraph/P1: 24px Regular */
    color: rgb(85, 98, 114);
    font-size: 24px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
@media (max-width: 1024px) {
.wrapper{
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
    gap: 24px;
}
.blog__f1__container .title{
        font-size: 32px;
    }
    .blog__f1__container .desc{
        font-size: 20px;
    }
}
@media (max-width: 768px) {
    .blog__f1__container .title{
        font-size: 24px;
    }
    .blog__f1__container .desc{
        font-size: 18px;
    }
    .wrapper{
        flex-direction: column;
    }
    .blog__f1__container{
        padding-top: 54px;
    }
}
</style>